import { Badge } from '@/components/ui/badge'
import type { DatasetTopicChipsProps } from '@/types/components/library/dataset-topic-chips'
import { LIBRARY_CARD_CHIP_CLASS } from './libraryCardStyles'

/** Existing topic and method facets; taxonomy codes never become topic tags. */
export function DatasetTopicChips({ facets = [] }: DatasetTopicChipsProps) {
  const labels = [...new Set(['category', 'method'].flatMap(kind =>
    facets.filter(facet => facet.kind === kind && !facet.rejected)
      .map(facet => facet.value.trim()).filter(Boolean),
  ))].slice(0, 3)
  if (labels.length === 0) return null
  return (
    <span className="flex flex-wrap gap-1.5" data-testid="dataset-topic-chips">
      {labels.map(label => (
        <Badge key={label} variant="muted" className={`${LIBRARY_CARD_CHIP_CLASS} max-w-full truncate`} title={label}>
          {label}
        </Badge>
      ))}
    </span>
  )
}
